// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1i_bQ","requiredAsterisk":"Info_requiredAsterisk__3Ol83"};